
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import TinyAccountInfo from "../../components/account/TinyInfo.vue";
import Player from "../../components/quickstart/Player.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { AuthService } from "@/services/auth-service";
import { Contact, ContactAddress, Product, Sale } from "@/models/base";
import AppCreateContact from "@/components/contacts/ContactEdit.vue";
import AppSaleEdit from "@/components/sales/SaleEdit.vue";
import AppDemoShedule from "@/components/account/DemoShedule.vue";
import { AllContactsService } from "@/services/all-contacts-service";
import { SaleService } from "@/services/sale-service";
import { ProductService } from "@/services/product-service";
import AppEditProduct from "@/components/products/ProductEdit.vue";

export default Vue.extend({
	data() {
		return {
			loaded: false,
			step: 1,
			play: false,
			videoId: 747652656,
			contactCreateModal: false,
			saleCreateModal: false,
			productCreateModal: false,
			newContact: new Contact(),
			newSale: new Sale(),
			newProduct: new Product(),
			toggleDemoShedule: false,
			contactCreated: false,
			invoiceCreated: false,
			productCreated: false
		};
	},
	computed: {
		progressTitle(): string {
			return this.$ct("start.progress-sub-title", {step: this.step}).toString();
		},
		welcomMsg(): string {

			let today = new Date();
			let hourNow = today.getHours();

			if (hourNow < 12) {
				return this.$ct("welcome.morning").toString();
			} else if (hourNow < 18) {
				return this.$ct("welcome.noon").toString();
			} else if (hourNow < 24) {
				return this.$ct("welcome.evening").toString();
			}
			return this.$ct("welcome.welcome").toString();

		},
		firstName(): string {
			if (!AuthService.wfUser) {
				return "";
			}
			return AuthService.wfUser.Firstname;
		},
		showQuickStart():boolean{
			return DossierConfigService.getGeneralConfig().ShowQuickStart;
		},
	},
	methods: {
		openContactCreateModal() {
			this.newContact = new Contact();
			this.newContact.MainAddress = new ContactAddress();
			this.newContact.MainAddress.IsMainAddress = true;
			this.newContact.Addresses = [this.newContact.MainAddress as ContactAddress];
			this.newContact.GroupID = 1;
			if (this.newContact.ExtraFields) {
				DossierConfigService.getExtraFieldNamesConfigs().getContactNamesByGroupID(1).setDefaultValues(this.newContact.ExtraFields);
			}
			this.contactCreateModal = true;
		},
		async openSaleCreateModal() {
			this.newSale.Type = await SaleService.getType(1);
			this.newSale.TypeID = 1;
			this.saleCreateModal = true;
		},
		async openProductCreateModal() {
			this.productCreateModal = true;
		},
		async validateProgress() {
			this.step = 1;
			let c = await AllContactsService.getContactCount();
			if (c > 0) {
				this.contactCreated = true;
				this.step++;
			}
			let s = await SaleService.getSalesCount();
			if (s > 0) {
				this.invoiceCreated = true;
				this.step++;
			}

			let p = await ProductService.getProductCount();
			if (p > 0) {
				this.productCreated = true;
				this.step++;
			}
		},
		async toggleQuickStart() {
			let c = DossierConfigService.getGeneralConfig();
			c.ShowQuickStart = !c.ShowQuickStart;
			await DossierConfigService.saveGeneralConfig(c);
		}
	},

	async mounted() {
		ToolbarService.title = this.$ct("title");
		this.validateProgress();
	},
	async created() {
		if (!DossierConfigService.getGeneralConfig().ShowQuickStart) {
			await this.$router.push("/home");
		}
		this.loaded = true;
	},
	components: {
		TinyAccountInfo,
		Player,
		AppCreateContact,
		AppSaleEdit,
		AppDemoShedule,
		AppEditProduct
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
